import { render, staticRenderFns } from "./AddSmartConfig.vue?vue&type=template&id=188cfa86&"
import script from "./AddSmartConfig.vue?vue&type=script&lang=js&"
export * from "./AddSmartConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AddSmartConfig.vue"
export default component.exports